// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { logger } from '@adornis/base/logging.js';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import '../db/index.js';
import '../i18n.js';
import { getGuestUserID } from './lib/guest-user-id.js';
import { App } from './App.js';
import './tailwind.css' with { type: 'tailwind' };

BaseQLClient.initDefault({
  getInitPayload: async (sessionID) => ({
    // Always forward the sessionID (it lives in localStorage) so logged-in users are not logged
    // out on every new tab or page refresh. The guestUserID lives in sessionStorage so the guest
    // identity is ephemeral per tab — these are independent and need not be in sync.
    sessionID,
    guestUserID: getGuestUserID(),
  }),
});

// Apply saved theme before first render to avoid flash of wrong theme.
// This mirrors the logic in settings-page.tsx but runs synchronously at startup.
(function applyInitialTheme() {
  const savedTheme = localStorage.getItem('theme') || 'system';
  const html = document.documentElement;
  html.classList.remove('light', 'dark');
  if (savedTheme === 'system') {
    html.classList.add(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  } else {
    html.classList.add(savedTheme);
  }
})();

// Subscribe to current user session — fills the currentUser observable
// so that the React useCurrentUser hook can reactively track login state.
subscribeCurrentUser().catch(err => logger.warn({ err }, 'subscribeCurrentUser failed'));

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(createElement(App));
}
